import { TableRow as MuiTableRow, TableRowProps as MuiTableRowProps } from "@mui/material";
import { useTheme } from "@mui/material";
import { clickableStyle } from "../../consts";
import { forwardRef } from "react";

type TableRowProps = MuiTableRowProps & {
  onEnter?: () => void;
};

export const TableRow = forwardRef<HTMLTableRowElement, TableRowProps>(
  ({ sx, children, onClick, onEnter, ...rest }, ref) => {
    const theme = useTheme();

    const handleClick = (e) => {
      if (onClick) {
        // prevents clicking event from happening when user is selecting text within the row
        var selection = window.getSelection();
        if (selection?.type != "Range") {
          onClick(e);
        }
      }
    };

    const handleKeyPress = (e) => {
      if (e.key === "Enter" && onEnter) {
        onEnter();
      }
    };

    return (
      <MuiTableRow
        ref={ref}
        sx={{
          ...sx,
          "&:hover": { backgroundColor: theme.palette.action.hover, cursor: onClick ? "pointer" : "unset" },
        }}
        onClick={handleClick}
        onKeyPress={handleKeyPress}
        {...rest}
      >
        {children}
      </MuiTableRow>
    );
  }
);
